import React from 'react'
import { DocFieldStyle } from './style'

const DocField = ({ value }: any) => (
  <DocFieldStyle>{value}</DocFieldStyle>
)

export default DocField